import React from 'react';
import StakeholderParticipationCompletionButton from './StakeholderParticipationCompletionButton.jsx';
import StakeholderParticipationLabel from '../StakeholderParticipationLabel.jsx';
import StakeholderParticipationStatus from '../../StakeholderParticipationStatus.jsx';
import styles from './StakeholderParticipationsTableRow.module.css';

const StakeholderParticipationsTableRow = ({
  isPreview,
  initiative,
  stakeholderParticipation,
}) => {
  const { children, name } = stakeholderParticipation;

  const renderParticipant = () => {
    if (children.length) {
      return (
        <StakeholderParticipationLabel
          isPreview={isPreview}
          initiative={initiative}
          stakeholderParticipation={stakeholderParticipation}
          showSurvey={false}
        />
      );
    }

    return (
      <strong
        className={`${stakeholderParticipation.archived ? 'text-muted' : ''}`}
      >
        {name}
      </strong>
    );
  };

  return (
    <tr className={styles.stakeholderParticipationsTableRow}>
      <td>{renderParticipant()}</td>
      {initiative.completionTracked && (
        <React.Fragment>
          <td style={{ width: '200px' }}>
            <StakeholderParticipationStatus
              initiative={initiative}
              stakeholderParticipation={stakeholderParticipation}
            />
          </td>
          <td
            className={`${styles.stakeholderParticipationsTableRow} ${styles.completionButton}`}
          >
            {!stakeholderParticipation.children.length && (
              <StakeholderParticipationCompletionButton
                isPreview={isPreview}
                initiative={initiative}
                stakeholderParticipation={stakeholderParticipation}
              />
            )}
          </td>
        </React.Fragment>
      )}
    </tr>
  );
};

export default StakeholderParticipationsTableRow;
